<script>
    import { Breadcrumb, BreadcrumbItem } from '@sveltestrap/sveltestrap';
    import { onMount } from 'svelte';
    import { fade } from 'svelte/transition';
    import { checkTicketExists } from '/public/services/User.js';
    import LoginUserOnly from '/public/components/user/LoginUserOnly.svelte';

    export let currentRoute;

    let hash = currentRoute.namedParams.hash; 
    let loading = true;
    let foundTicket = false;
    let hasUser = false;
    let url = null;

    function checkTicket() {
        loading = true;
        foundTicket = true;
        hasUser = true;

        checkTicketExists(hash).then(res => {
            if (res.success) {
                foundTicket = res.data.found;

                if (foundTicket === true) {
                    hasUser = res.data.user;
                }

                if (hasUser === true) {
                    url = res.data.url;

                    window.location = url;
                }

                loading = false;
            }
        });
    }

    function loginEvent(evt) {
        checkTicket();
    }

    onMount(() => {
        checkTicket();
    });
</script>
<Breadcrumb>
    <BreadcrumbItem>
        <a href="/u/dashboard">
            Dashboard
        </a>
    </BreadcrumbItem>
    <BreadcrumbItem active>            
        Ticket Director
    </BreadcrumbItem>           
</Breadcrumb>

{#if loading === true}

    <div class='text-center mt-5 mb-5'>
        <h4>
            <span class='ajax-ball-loader'></span> Loading your Ticket...
        </h4>
    </div>

{:else}

    {#if foundTicket === false}

        <div class='alert alert-info clearfix mt-5 mb-5' in:fade>
            <h4 class='float-start me-2'>
                <span class='fas fa-info-circle'></span>
            </h4>
            Your Ticket could not be found.
        </div>

    {/if}
    
    {#if hasUser === false}

        <div class='alert alert-info clearfix mt-5 mb-5' in:fade>
            <h4 class='float-start me-2'>
                <span class='fas fa-info-circle'></span>
            </h4>
            You must be logged in to view this Ticket.
        </div>

        <LoginUserOnly
            on:logged-in={loginEvent}
        />

    {/if}


{/if}